module.exports = __webpack_public_path__ + "static/media/logo-price-cae.f6328f6d.svg";